import { Button } from 'antd';

import styles from '../MaxBookingDrawer.module.scss';

type MaxBookingFooterProps = {
  handleClose: () => void;
  saveDisabled?: boolean;
  handleSave: () => void;
};

export const MaxBookingFooter = ({
  handleClose,
  saveDisabled,
  handleSave,
}: MaxBookingFooterProps) => {
  return (
    <div className={styles.footer}>
      <Button onClick={handleClose}>Cancel</Button>
      <Button type="primary" onClick={handleSave} disabled={saveDisabled}>
        Save
      </Button>
    </div>
  );
};
